import {fetch,promptMessage} from './dataHandling';
import {baseUrl} from '../utils/request';
import {urlConfig} from './urlConfig';
import axios from 'axios';
function getken(obj){
  axios.post(baseUrl+urlConfig.getToken,{"username":"weixin", "password":"7e024f06119f32a5d102c8b7e9801a1f"}).then(response => {
    if (response.data.resultCode == 'success'){
      window.localStorage.token = response.data.data;
      if(obj){

        obj();
      }

    }else{
      promptMessage('提示',response.data.resultMsg)
      window.localStorage.token = null;
    }

  }).catch(error => {
    alert(error)
  })

}
export {getken};







// WEBPACK FOOTER //
// ./src/api/getToken.js